import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { OfferLanguageItem, OfferLanguagesSetup } from '@recruitee/http/types';

@Injectable({
  providedIn: 'root',
})
export class OfferLanguagesHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(id: number): Observable<{ offerId: number; setup: OfferLanguagesSetup }> {
    return this.httpApi.get(`/offers/${id}/languages`).pipe(
      map(response => ({
        offerId: id,
        setup: response,
      })),
    );
  }

  public toggleLanguageItem$(props: {
    offerId: number;
    code: string;
    enabled: boolean;
  }): Observable<OfferLanguageItem> {
    return this.httpApi.patch(`/offers/${props.offerId}/languages/${props.code}`, null, {
      language: { enabled: props.enabled },
    });
  }

  public setPrimaryLanguage$(props: {
    offerId: number;
    code: string;
  }): Observable<OfferLanguageItem> {
    return this.httpApi.patch(`/offers/${props.offerId}/languages/${props.code}`, null, {
      language: { make_primary: true },
    });
  }
}
